import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DownloadComponent } from './index';

export const DownloadRoutes: Routes = [
    {
        path: 'download',
        component: DownloadComponent
    }
];

export const DownloadRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(DownloadRoutes);
